<template>
  <div class="panel">
    <div class="panel-header">
      <div class="flex justify-between items-center text-sm">
        <span> Request Approval</span>
        <div>
          <div v-if="pubCampaignsLoading">
            <v-icon class="ov-spin" name="ri-loader-5-line" />
          </div>
          <div v-else>
            <button  @click="emitClose">
              <v-icon name="io-close" />
            </button>
            
          </div>
        </div>
      </div>
    </div>
    <div class="panel-body">
      <template v-if="requestLimitHit">
        <Banner color="yellow">
          You have reached the maximum allowed number of campaign requests.
        </Banner>
      </template>
      <template v-else>
        <div class="text-sm mb-3">
          Please describe your traffic and how you plan to promote it.
        </div>
        <textarea
          v-model="reason"
          class="w-full px-2 py-3 ai-input-class bg-base-100"
          placeholder="Type here..."
        ></textarea>
      </template>
      <div class="flex mt-3 justify-end">
        <XButton
          color="primary"
          @click="submit"
          :is-loading="isSubmitting"
          :disabled="!canSubmit"
        >Submit Request</XButton>
      </div>
    </div>
    <!-- <ValidationErrors
      v-if="validationErrors"
      :errors="validationErrors"
    ></ValidationErrors> -->
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useQuery, useMutation } from '@vue/apollo-composable';
import REQUEST_CAMPAIGN_APPROVAL_MUTATION from '@/graphql/PublisherCampaign/RequestCampaignApprovalMutation.gql';
import PUBLISHER_CAMPAIGNS_QUERY from '@/graphql/PublisherCampaign/PublisherCampaignsQuery.gql';

// import { useValidationErrors } from '@/mixins/ValidationErrorsMixin';
import Banner from '@/components/common/Banner.vue';

const emit = defineEmits(['close']);
const props = defineProps({
  campaignId: {
    type: [Number, String],
    required: true
  }
});

const reason = ref(null);
const isSubmitting = ref(false);
const requestedLimit = 10;
// const validationErrors = useValidationErrors();

// Apollo query
const { result: publisherCampaignsResult, loading: pubCampaignsLoading } = useQuery(PUBLISHER_CAMPAIGNS_QUERY, {
  first: 1,
  filters: {
    publisherStatus: {
      value: ['pending approval']
    }
  }
}, { fetchPolicy: 'network-only' });

const requestedCount = computed(() => {
  return publisherCampaignsResult.value?.publisherCampaigns?.paginatorInfo?.total ?? null;
});

const canSubmit = computed(() => !pubCampaignsLoading.value && !requestLimitHit.value);
const requestLimitHit = computed(() => {
  if (requestedCount.value === null) {
    return false;
  } else if (requestedCount.value >= requestedLimit) {
    return true;
  }
  return false;
});

// Apollo mutation
const { mutate: requestCampaignApproval } = useMutation(REQUEST_CAMPAIGN_APPROVAL_MUTATION);

function emitClose() {
  emit('close');
}

function submit() {
  isSubmitting.value = true;
  requestCampaignApproval({
    input: {
      campaignId: props.campaignId,
      reason: reason.value
    }
  }).then(() => {
    // validationErrors.clear();
    isSubmitting.value = false;
    emitClose();
  }).catch(error => {
    // validationErrors.set(error);
    isSubmitting.value = false;
  });
}
</script>

<style></style>